module.exports = __webpack_public_path__ + "img/subway.a66d5614.png";